module.exports = __webpack_public_path__ + "static/img/aaaaaa@3x.75d77064.png";